import { Box } from "@mui/material";
import NewHeader from "../../components/Header/NewHeader";
import AppSidebar from "../../components/dashboard/Appsidebar";
import DoorReturnMonitoringContainer from "../../components/dashboard/DoorReturnMonitoringContainer";

function DoorAlarmPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#f3f4f6",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <NewHeader />

      <Box sx={{ display: "flex", flex: 1 }}>
        <AppSidebar />

        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            px: { xs: 1.5, sm: 2, md: 2.5 },
            pt: { xs: 1.5, sm: 2, md: 2.5 },
            pb: { xs: 2, md: 3 },
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1.5, md: 2 },
            mt: 2,
          }}
        >
          <DoorReturnMonitoringContainer />
        </Box>
      </Box>
    </Box>
  );
}

export default DoorAlarmPage;
